import HeadTags from '@finn/b2b-ui/components/HeadTags';
import type { BasePageData, CosmicFactory } from '@finn/ui-cosmic';
import * as React from 'react';

import { AppLayout } from '../layouts';
import { SpacingWrapper } from './SpacingWrapper';

type Props = {
  factory: CosmicFactory;
  data: BasePageData;
  children?: React.ReactNode;
  layout?: 'public' | 'authenticated';
};

const BasePageBodyBuilder: React.FunctionComponent<Props> = ({
  factory,
  data,
  children,
}) => {
  const { modules, seo_header } = data.metadata;
  const CosmicModule = React.useMemo(() => factory.make(), [factory]);

  return (
    <AppLayout>
      <AppLayout.Main>
        <HeadTags seoHeader={seo_header} />
        {modules.map((module) => (
          <SpacingWrapper key={module.slug}>
            <CosmicModule data={module} />
          </SpacingWrapper>
        ))}
        {children}
      </AppLayout.Main>
    </AppLayout>
  );
};

export const PageBodyBuilder = React.memo(BasePageBodyBuilder);
